<template>
  <div
    :class="$style.root"
    :data-expanded="expanded ? '' : null"
    ref="root"
  >
    <button
      @click="expanded = !expanded"
      :class="$style.button"
    >
      <LayoutTextWithBarComponent>{{ currentLocale }}</LayoutTextWithBarComponent>
    </button>

    <!-- <transition name="slide-in"> -->
      <ul
        v-show="expanded && sticky"
        :class="$style.list"
      >
        <li v-for="locale in unusedLocales" :key="locale.code">
          <NuxtLink
          :key="locale.code"
          :to="switchLocalePath(locale.code)"
          :class="$style.link"
          :data-current=" currentLocale === locale.code ? '' : null "
          @click="expanded = false"
          >
            <LayoutTextWithBarComponent>{{ locale.code }}</LayoutTextWithBarComponent>
          </NuxtLink>
        </li>
      </ul>
    <!-- </transition> -->
  </div>
</template>

<script setup>
const props = defineProps({
  sticky: {
    type: Boolean,
    default: false,
  },
});

const root = ref(null)

const { locale: currentLocale, locales } = useI18n()
const unusedLocales = computed(() => {
  return locales.value.filter(locale => locale.code !== currentLocale.value)
})

const switchLocalePath = useSwitchLocalePath()

const expanded = ref(false)

onClickOutside(root, () => {
  expanded.value = false
}, { ignore: ['button', 'a'] })
</script>

<style module>
.root {
  position: relative;
}

.item {
  text-transform: uppercase;

  display: flex;
  text-align: center;

  --button--hover--background-color: var(--color--gray);
  --button--current--background-color: var(--color--gray);
}

.button {
  composes: reset-button button from global;
  composes: item;

  position: relative;
  z-index: 2;
}

.button:hover,
.root[data-expanded] .button {
  color: var(--color--pink);
}

.list {
  composes: reset-list from global;

  position: absolute;
  top: var(--font-default--line-height);
  right: 0;

  display: flex;
  flex-direction: column;
  align-items: flex-end;

  z-index: 1;
}

.link {
  composes: reset-link from global;
  composes: item;
}

.link:hover,
.link[data-current] {
  color: var(--color--pink);
}

.link:not([href]) {
  pointer-events: none;
  color: var(--color--gray);
}
</style>
